<form [formGroup]="print_form" class="space-y-6" action="#" method="POST">
  <div class="sm:grid grid-cols-3 gap-3">
    <div class="col-span-1">
      <label class="ms-1 text-sm text-gray-800">
        Tipo de Impresion
      </label>
      <div class="relative mt-2 rounded-md shadow-sm">
        <select type="text" name="print_type" id="print_type" class="form-control block w-full rounded-xl baction-0 py-2 px-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 sm:text-sm sm:leading-6 focus:primary-ring-color outline-none appearance-none"
          placeholder="Tipo de Impresion"
          formControlName="print_type"
          autocomplete="off" [ngClass]="{
            'is-invalid': print_form.controls['print_type'].invalid,
            'is-valid': print_form.controls['print_type'].valid}"
        >
        <option value="gama">Gama única (Imprime una única gama)</option>
        <option value="order">Gamas OT (Imprime todas las gamas de la OT)</option>
      </select>
      </div>
    </div>

    <div class="{{print_form.value.print_type === 'order' ? 'col-span-2' : 'col-span-1'}}">
      <label class="ms-1 text-sm text-gray-800">
        Nº Orden de trabajo
      </label>
      <div class="relative mt-2 rounded-md shadow-sm">
        <input type="text" name="order_number" id="order_number" class="form-control block w-full rounded-xl baction-0 py-2 px-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 sm:text-sm sm:leading-6 focus:primary-ring-color outline-none appearance-none"
          placeholder="Número de la orden de trabajo"
          formControlName="order_number"
          autocomplete="off" [ngClass]="{
            'is-invalid': print_form.controls['order_number'].invalid,
            'is-valid': print_form.controls['order_number'].valid}"
        />
      </div>
    </div>

    <div *ngIf="print_form.value.print_type === 'gama'" class="col-span-1">
      <label class="ms-1 text-sm text-gray-800">
        Nº Gama
      </label>
      <div class="relative mt-2 rounded-md shadow-sm">
        <input type="text" name="gama_number" id="gama_number" class="form-control block w-full rounded-xl baction-0 py-2 px-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 sm:text-sm sm:leading-6 focus:primary-ring-color outline-none appearance-none"
          placeholder="Número de la gama"
          formControlName="gama_number"
          autocomplete="off" [ngClass]="{
            'is-invalid': print_form.controls['gama_number'].invalid,
            'is-valid': print_form.controls['gama_number'].valid}"
        />
      </div>
    </div>
  </div>


  <div class="flex justify-between py-4 gap-x-3">
    <div>
      <p class="{{ message.status === 'success' ? 'text-green-500' : 'text-red-600' }}">
        {{ message.text }}
      </p>
    </div>
    <div class="flex gap-x-3">
      <button [disabled]="form_in_progress" (click)="print()" type="submit" class="primary-button flex justify-center rounded-xl px-10 py-2.5 text-base font-semibold leading-6 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-700">
        {{ print_form.value.print_type === 'gama' ? 'Imprimir Gama' : 'Imprimir gamas de la OT' }}
      </button>
    </div>
  </div>
</form>